import { useCallback } from 'react';

import { useBusinessEntity } from '@zenbusiness/application-commons-business-entity';
import { gql, useQuery } from '@zenbusiness/application-commons-graphql';
import { useIdentity } from '@zenbusiness/application-commons-identity';
import Title from '@zenbusiness/common-components/Title';
import { snakeCase } from 'lodash';

import LinearProgress from '@mui/material/LinearProgress';

import LessonCard from '../../components/LessonCard';

import { useLessonsGridData } from '../../hooks/useLessonsGridData';
import { useSeriesScrollPosition } from '../../hooks/useSeriesScrollPosition';
import { ArticleCard } from '../components/ArticleCard/ArticleCard';
import { Carousel } from '../components/Carousel/Carousel';
import { Series as SeriesComponent } from '../components/Series/Series';

export const GET_ARTICLES_SERIES = gql`
  query GetArticlesSeries {
    series: allArticleSeries {
      uuid
      title
      key
      articles {
        title
        key
        thumbnailUrl: thumbnailPath
      }
    }
  }
`;

const EDU_CARD_SELECTED = 'edu_card_selected';
const J2S_SERIES = 'entrepreneurial_mindset';

export const Series = () => {
  const { businessEntityUuid } = useBusinessEntity();
  const { accountUuid } = useIdentity();

  const { loading: loadingArticles, data: articlesSeries } = useQuery(GET_ARTICLES_SERIES);
  const {
    isLoading: loadingLessons,
    lessons
  } = useLessonsGridData(accountUuid, businessEntityUuid);
  const { getSelectedCard } = useSeriesScrollPosition(null, EDU_CARD_SELECTED, null, null);
  const { series: selectedSeries, card: selectedCard } = getSelectedCard() || {};

  const isCardSelected = useCallback(
    (series, card) => series === selectedSeries && card === selectedCard,
    [selectedCard, selectedSeries]
  );
  // Todo EDU track carousel interaction
  return loadingArticles || loadingLessons ? <LinearProgress /> : (
    <>
      <Title variant="md-alt">What do you want to explore?</Title>
      {articlesSeries.series.map(({ title: seriesTitle, key: seriesKey, articles }) => (
        <SeriesComponent title={seriesTitle} resources={articles.length} key={seriesKey}>
          <Carousel>
            {articles.map(({ title: articleTitle, key: articleKey, thumbnailUrl }) => (
              <ArticleCard
                key={articleKey}
                name={articleTitle}
                thumbnailUrl={thumbnailUrl}
                seriesKey={seriesKey}
                articleKey={articleKey}
                focusCard={isCardSelected(seriesKey, articleKey)}
              />
            ))}
          </Carousel>
        </SeriesComponent>
      ))}
      <SeriesComponent title="Entrepreneurial mindset" resources={lessons.length}>
        <Carousel>
          {lessons.map((lesson) => (
            <LessonCard
              key={lesson.name}
              lesson={lesson}
              focusCard={isCardSelected(J2S_SERIES, snakeCase(lesson.name))}
            />
          ))}
        </Carousel>
      </SeriesComponent>
    </>
  );
};
